import React, {createElement} from "react";
import HeadlineOne from "./headline-h1";
import HeadlineTwoWithAnchor from "~components/markdown/renderers/headline-h2";
import HeadlineThreeWithAnchor from "~components/markdown/renderers/headline-h3";
import HeadlineFourWithAnchor from "~components/markdown/renderers/headline-h4";

type PropTypes = {
    level: number;
    children: any;
}

function HeadingRenderer(props: PropTypes) {
    switch (props.level) {
        case 1:
            return (
                <HeadlineOne>
                    {props.children}
                </HeadlineOne>
            );
        case 2:
            return (
                <HeadlineTwoWithAnchor>
                    {props.children}
                </HeadlineTwoWithAnchor>
            );
        case 3:
            return (
                <HeadlineThreeWithAnchor>
                    {props.children}
                </HeadlineThreeWithAnchor>
            );
        case 4:
            return (
                <HeadlineFourWithAnchor>
                    {props.children}
                </HeadlineFourWithAnchor>
            );
        default:
            // fallback to their way: https://github.com/remarkjs/react-markdown/blob/62a683f18c19d08b165de6edc32c23ea4d6ebd5b/src/renderers.js#L69-L71
            return createElement(`h${props.level}`, props.children);
    }
}

export default HeadingRenderer;
